module.exports = __webpack_public_path__ + "img/eq-archon-plate.2f67315e.png";